import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled as styledMui } from '@mui/material/styles';

export const LinearProgressDark = styledMui(LinearProgress)(({ theme }) => ({
    height: 24,
    borderRadius: 50,
    marginInline: 37,

    [`&.${linearProgressClasses.colorPrimary}`]: {
        background: 'rgba(29, 29, 29, 0.6)',
    },

    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 50,
        background: theme.colors.primary.main,
    },
}));

export const LinearProgressLight = styledMui(LinearProgress)(({ theme }) => ({
    height: 11,
    borderRadius: 50,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        background: '#f3f3f3',
    },
    [`& .${linearProgressClasses.bar}`]: {
        background: theme.colors.primary.main,
    },
}));
